import { Injectable } from '@angular/core';
import { Theme } from '@ip-only/front-end-library';
import { BehaviorSubject } from 'rxjs';

export enum SelfserviceThemeName {
  GlobalConnect = 'GlobalConnect',
}

export interface SelfserviceTheme {
  name: SelfserviceThemeName;
  faviconUrl: string;
  logoUrl: string;
}

export const globalConnectTheme: SelfserviceTheme = {
  name: SelfserviceThemeName.GlobalConnect,
  faviconUrl:
    'https://assets.globalconnect.net/images/favicon/gc/favicon-32x32.png',
  logoUrl:
    'https://assets.globalconnect.net/images/logos/gc-svg/horizontal/gc-logo-hor-blue.svg',
};
export const themes: SelfserviceTheme[] = [globalConnectTheme];

@Injectable({ providedIn: 'root' })
export class SelfserviceThemeService {
  private _theme = new BehaviorSubject<SelfserviceTheme>(globalConnectTheme);
  private _faviconLink: HTMLLinkElement;

  public get theme(): SelfserviceTheme {
    return this._theme.getValue();
  }

  public set theme(themeName: SelfserviceThemeName) {
    const selectedTheme =
      themes.find((theme) => theme.name === themeName) ?? globalConnectTheme;
    this._theme.next(selectedTheme);

    this.setTitle();
    this.setFavicon();
  }

  public init(): Promise<void> {
    this.theme = SelfserviceThemeName.GlobalConnect;

    const libTheme = Theme.GC_PUBLIC;

    document.body.setAttribute('class', 'theme-' + libTheme);

    document.body.style.setProperty(
      '--font-family',
      'Circular Pro, Arial, Helvetica, sans-serif'
    );

    return Promise.resolve();
  }

  private setTitle() {
    document.title = this.theme.name + ' - Självbetjäningsportal';
  }

  private setFavicon() {
    this._faviconLink = document.querySelector(
      "link[rel='icon']"
    ) as HTMLLinkElement;

    if (!this._faviconLink) {
      this._faviconLink = document.createElement('link');
      this._faviconLink.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(this._faviconLink);
    }

    this._faviconLink.href = this._theme.getValue().faviconUrl;
  }
}
